
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30275',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30275",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54544",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8010",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11467",
  "I18n": "static-7.1624",
  "quartz": "static-1.7028",
  "quartz-config": "static-1.806",
  "quartz-core": "static-1.6247",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.790",
  "enviro": "static-4.446",
  "feedback-shared-ui": "static-1.54531",
  "feedback-utils": "static-1.54535",
  "forms-embed-utils-lib": "static-1.4459",
  "forms-utils-lib": "static-1.12574",
  "foundations-assets": "static-1.4862",
  "foundations-components": "static-1.7928",
  "foundations-theming": "static-1.4413",
  "hub-http": "static-1.6219",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11774",
  "icons": "static-2.646",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3912",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16668",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5339",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57466",
  "transmute": "static-2.85",
  "ui-images": "static-2.1153",
  "UIComponents": "static-3.8413",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3395",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3305",
  "quartz-webpack": "static-1.3252",
  "foundations-theming-specialty": "static-1.2129",
  "property-description-translator": "static-1.3841",
  "HeadJS": "static-2.760",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3121",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4324",
  "jasmine-runner": "static-1.6462",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.833",
  "hubspotter-http": "static-1.4647",
  "mobile-manifest-mixins": "static-1.534",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.703",
  "quartz-head": "static-1.693",
  "quartz-i18n": "static-1.703",
  "quartz-routing": "static-1.458",
  "quartz-test": "static-1.703",
  "quartz-tracking": "static-1.407",
  "ui-fonts": "static-1.729",
  "usage-tracker-container": "static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "static-1-cwunder-improve-network-queue-resilience.2",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7243",
  "reference-resolvers": "static-1.8168",
  "sanitize-text": "static-1.8138",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10363",
  "sanitize": "static-1.4473",
  "outpost": "static-1.4179",
  "rpc-client-utils": "static-1.4647",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4197",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9422",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.22",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1922",
  "bend-plugin-foundations-theming": "static-1.2896",
  "foundations-theming-base": "static-1.3398",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.76",
  "csstype": "static-1.50",
  "web-vitals": "static-1.5",
  "ai-components-ui-library": "static-1.8961",
  "atom": "static-1.5068",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7747",
  "ContentUtils": "static-1.68348",
  "data-token-picker": "static-1.16405",
  "file-manager-components": "static-1.23614",
  "FileManagerCore": "static-1.39113",
  "FileManagerLib": "static-1.39254",
  "frontend-preferences-client": "static-1.7925",
  "hub-http-contrib": "static-1.3039",
  "interframe": "static-3.4756",
  "layout-dnd-components": "static-1.12443",
  "layout-dnd-utils": "static-1.11418",
  "property-translator": "static-1.5397",
  "react-codemirror": "static-1.10623",
  "react-colorpicker": "static-2.10204",
  "reference-resolvers-lite": "static-1.8091",
  "rich-text-lib": "static-1.19828",
  "tinymce-data": "static-1.40437",
  "tinymce-themes": "static-1.56322",
  "ui-addon-emoji-picker": "static-1.9885",
  "ui-addon-sales-email": "static-1.5208",
  "ui-brand-identity-lib": "static-1.15258",
  "bender-build-tools": "static-1.3199",
  "hub-http-shared-msw-handlers": "static-1.9949",
  "hubspotter-http-shared-msw-handlers": "static-1.9947",
  "usage-tracker-session-replay": "static-1-cwunder-improve-network-queue-resilience.2",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.57",
  "chirp-fetch": "static-1.1884",
  "chatspot-core": "static-1.21272",
  "copilot-toolkit": "static-1.11123",
  "customer-data-objects-ui-components": "static-1.13023",
  "data-fetching-client": "static-1.9666",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4758",
  "ui-addon-video-player": "static-1.8699",
  "ui-coaching-tips": "static-1.28539",
  "usage-tracker": "static-1-cwunder-improve-network-queue-resilience.2",
  "cms-field-types": "static-1.4807",
  "content-icons-ui": "static-1.2225",
  "integrations-lib": "static-1.16102",
  "customer-data-objects": "static-1.7666",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4646",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4151",
  "ui-addon-iframeable": "static-1.9053",
  "video-components-external": "static-1.11247",
  "video-data-lib": "static-1.34905",
  "audio-components": "static-1.5911",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29291",
  "FileManagerImages": "static-1.36765",
  "foundations-components-legacy": "static-1.953",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.8973",
  "urlinator": "static-1.4533",
  "video-components": "static-1.13250",
  "video-embed": "static-1.35739",
  "ts-schema": "static-1.4075",
  "ContentData": "static-1.68423",
  "layout-data-lib": "static-1.9743",
  "react-dnd-compat": "static-1.4612",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1537",
  "external-options-client-types": "static-1.4153",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6880",
  "hs-promise-utils": "static-1.5589",
  "inbound-db-properties-service-client": "static-1.3841",
  "NamespacedHubStyle": "static-2.9054",
  "growth-onboarding-confetti": "static-1.3063",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11147",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5549",
  "magpie-types": "static-1.5009",
  "simple-logging-lib": "static-1.3045",
  "avatar-components": "static-1.2494",
  "customer-data-ui-utilities": "static-1.9822",
  "growth-onboarding-feedback-components": "static-1.6577",
  "flux-actions": "static-1.337",
  "hubspot-apollo-client": "static-1.4875",
  "integrations-error-boundary-lib": "static-1.13517",
  "integrations-tracking-lib": "static-1.5598",
  "laboratory-lib": "static-3.7153",
  "native-integrations-shared-strings": "static-1.7779",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10160",
  "unified-auth": "static-1.487",
  "navigation-messaging": "static-1.7346",
  "content-media-composition-data-lib": "static-1.12247",
  "content-media-compositions": "static-2.16254",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18922",
  "unified-auth-core-lib": "static-1.769",
  "social-insights-client-types": "static-1.22085",
  "advanced-menus-core": "static-1.15122",
  "advanced-menus-lib": "static-1.12064",
  "ExportDialog": "static-6.10386",
  "ui-memberships-settings-lib": "static-1.34031",
  "conditional-properties-service-client": "static-1.3792",
  "crm-pipelines-api-client-types": "static-1.4133",
  "framework-builder-read-service-client": "static-1.4000",
  "framework-data-schema-quick-fetch": "static-1.6785",
  "inbound-db-meta-service-client": "static-1.3580",
  "multi-currency-client-types": "static-1.3686",
  "persist-promise": "static-1.3694",
  "foundations-components-test-utils": "static-1.5411",
  "reactive-lib": "static-1.720",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.334",
  "universal-page-editor-lib": "static-1.3010",
  "google-sheets-integration-lib": "static-1.221",
  "microsoft-drive-integration-lib": "static-1.340",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3727",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15121",
  "simple-menus-lib": "static-1.16638",
  "crm-record-cards-service-types": "static-1.3592",
  "location-customization-utils-lib": "static-1.9239",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30275",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54544",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8010",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11467",
  "I18n": "/I18n/static-7.1624",
  "quartz": "/quartz/static-1.7028",
  "quartz-config": "/quartz-config/static-1.806",
  "quartz-core": "/quartz-core/static-1.6247",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.790",
  "enviro": "/enviro/static-4.446",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54531",
  "feedback-utils": "/feedback-utils/static-1.54535",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4459",
  "forms-utils-lib": "/forms-utils-lib/static-1.12574",
  "foundations-assets": "/foundations-assets/static-1.4862",
  "foundations-components": "/foundations-components/static-1.7928",
  "foundations-theming": "/foundations-theming/static-1.4413",
  "hub-http": "/hub-http/static-1.6219",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11774",
  "icons": "/icons/static-2.646",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3912",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16668",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5339",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57466",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1153",
  "UIComponents": "/UIComponents/static-3.8413",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3395",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3305",
  "quartz-webpack": "/quartz-webpack/static-1.3252",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2129",
  "property-description-translator": "/property-description-translator/static-1.3841",
  "HeadJS": "/HeadJS/static-2.760",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3121",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4324",
  "jasmine-runner": "/jasmine-runner/static-1.6462",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.833",
  "hubspotter-http": "/hubspotter-http/static-1.4647",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.534",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.703",
  "quartz-head": "/quartz-head/static-1.693",
  "quartz-i18n": "/quartz-i18n/static-1.703",
  "quartz-routing": "/quartz-routing/static-1.458",
  "quartz-test": "/quartz-test/static-1.703",
  "quartz-tracking": "/quartz-tracking/static-1.407",
  "ui-fonts": "/ui-fonts/static-1.729",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-improve-network-queue-resilience.2",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-improve-network-queue-resilience.2",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7243",
  "reference-resolvers": "/reference-resolvers/static-1.8168",
  "sanitize-text": "/sanitize-text/static-1.8138",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10363",
  "sanitize": "/sanitize/static-1.4473",
  "outpost": "/outpost/static-1.4179",
  "rpc-client-utils": "/rpc-client-utils/static-1.4647",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4197",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9422",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.22",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1922",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2896",
  "foundations-theming-base": "/foundations-theming-base/static-1.3398",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.76",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.5",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8961",
  "atom": "/atom/static-1.5068",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7747",
  "ContentUtils": "/ContentUtils/static-1.68348",
  "data-token-picker": "/data-token-picker/static-1.16405",
  "file-manager-components": "/file-manager-components/static-1.23614",
  "FileManagerCore": "/FileManagerCore/static-1.39113",
  "FileManagerLib": "/FileManagerLib/static-1.39254",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7925",
  "hub-http-contrib": "/hub-http-contrib/static-1.3039",
  "interframe": "/interframe/static-3.4756",
  "layout-dnd-components": "/layout-dnd-components/static-1.12443",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11418",
  "property-translator": "/property-translator/static-1.5397",
  "react-codemirror": "/react-codemirror/static-1.10623",
  "react-colorpicker": "/react-colorpicker/static-2.10204",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8091",
  "rich-text-lib": "/rich-text-lib/static-1.19828",
  "tinymce-data": "/tinymce-data/static-1.40437",
  "tinymce-themes": "/tinymce-themes/static-1.56322",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9885",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5208",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15258",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9949",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9947",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-improve-network-queue-resilience.2",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.57",
  "chirp-fetch": "/chirp-fetch/static-1.1884",
  "chatspot-core": "/chatspot-core/static-1.21272",
  "copilot-toolkit": "/copilot-toolkit/static-1.11123",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13023",
  "data-fetching-client": "/data-fetching-client/static-1.9666",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4758",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8699",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28539",
  "usage-tracker": "/usage-tracker/static-1-cwunder-improve-network-queue-resilience.2",
  "cms-field-types": "/cms-field-types/static-1.4807",
  "content-icons-ui": "/content-icons-ui/static-1.2225",
  "integrations-lib": "/integrations-lib/static-1.16102",
  "customer-data-objects": "/customer-data-objects/static-1.7666",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4646",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4151",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9053",
  "video-components-external": "/video-components-external/static-1.11247",
  "video-data-lib": "/video-data-lib/static-1.34905",
  "audio-components": "/audio-components/static-1.5911",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29291",
  "FileManagerImages": "/FileManagerImages/static-1.36765",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.953",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.8973",
  "urlinator": "/urlinator/static-1.4533",
  "video-components": "/video-components/static-1.13250",
  "video-embed": "/video-embed/static-1.35739",
  "ts-schema": "/ts-schema/static-1.4075",
  "ContentData": "/ContentData/static-1.68423",
  "layout-data-lib": "/layout-data-lib/static-1.9743",
  "react-dnd-compat": "/react-dnd-compat/static-1.4612",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1537",
  "external-options-client-types": "/external-options-client-types/static-1.4153",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6880",
  "hs-promise-utils": "/hs-promise-utils/static-1.5589",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3841",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9054",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3063",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11147",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5549",
  "magpie-types": "/magpie-types/static-1.5009",
  "simple-logging-lib": "/simple-logging-lib/static-1.3045",
  "avatar-components": "/avatar-components/static-1.2494",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9822",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6577",
  "flux-actions": "/flux-actions/static-1.337",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4875",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13517",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5598",
  "laboratory-lib": "/laboratory-lib/static-3.7153",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7779",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10160",
  "unified-auth": "/unified-auth/static-1.487",
  "navigation-messaging": "/navigation-messaging/static-1.7346",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12247",
  "content-media-compositions": "/content-media-compositions/static-2.16254",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18922",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.769",
  "social-insights-client-types": "/social-insights-client-types/static-1.22085",
  "advanced-menus-core": "/advanced-menus-core/static-1.15122",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12064",
  "ExportDialog": "/ExportDialog/static-6.10386",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34031",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3792",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4133",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4000",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6785",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3580",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3686",
  "persist-promise": "/persist-promise/static-1.3694",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5411",
  "reactive-lib": "/reactive-lib/static-1.720",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.334",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3010",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.221",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.340",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3727",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15121",
  "simple-menus-lib": "/simple-menus-lib/static-1.16638",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3592",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9239",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
